module.exports = __webpack_public_path__ + "img/Russell_Queen_and_Mott_The_Hoople_141273.original.6b03ab11.jpg";